import i18next from 'i18next';
import {
	VehicleStateEnum,
	HistoryActionTypeEnum,
	RoleEnum,
	VehcileAvailabilityEnum,
	OpportunityStageEnum,
	LeadCallResponseEnum,
	LeadMotivationEnum,
} from '../api/models/Enums';

const translateAndFormatText = (
	key: string,
	uppercase: boolean = true
): string => {
	key = key.toLowerCase();
	if (uppercase) {
		return i18next.t(key).toUpperCase();
	}

	return i18next.t(key);
};

export const translateVehicleStates = (
	state: VehicleStateEnum | null | string
): string => {
	switch (state) {
		case VehicleStateEnum.DISPONIBILE:
			return translateAndFormatText('available');
		case VehicleStateEnum.OPZIONATO:
			return translateAndFormatText('optioned');
		case VehicleStateEnum.OSCURATO:
			return translateAndFormatText('obscured');
		case VehicleStateEnum.VENDUTO:
			return translateAndFormatText('sold');
		default:
			return '';
	}
};

export const translateVehicleAvailabilityState = (
	state: VehcileAvailabilityEnum
): string => {
	switch (state) {
		case VehcileAvailabilityEnum.TARGATO:
			return translateAndFormatText('registered');
		case VehcileAvailabilityEnum.TELAIATO:
			return translateAndFormatText('framed');
		case VehcileAvailabilityEnum.IN_ARRIVO:
			return translateAndFormatText('incoming');
		case VehcileAvailabilityEnum.ORDINATO:
			return translateAndFormatText('ordered');
		default:
			return '';
	}
};

export const translateRoles = (state: RoleEnum): string => {
	switch (state) {
		case RoleEnum.FLEET_MANAGER:
			return translateAndFormatText('fleet_manager');
		default:
			return state;
	}
};

export const translateStoricoAzioneStates = (
	state: HistoryActionTypeEnum
): string => {
	switch (state) {
		case HistoryActionTypeEnum.DISPONIBILE:
			return translateAndFormatText('available');
		case HistoryActionTypeEnum.OPZIONAMENTO:
			return translateAndFormatText('optioning');
		case HistoryActionTypeEnum.OPZIONAMENTO_CANCELLATO:
			return translateAndFormatText('optioningCancelled');
		case HistoryActionTypeEnum.OPZIONAMENTO_RINNOVATO:
			return translateAndFormatText('optioningRenewed');
		case HistoryActionTypeEnum.OPZIONAMENTO_SCADUTO:
			return translateAndFormatText('optioningExpired');
		case HistoryActionTypeEnum.OSCURAMENTO:
			return translateAndFormatText('obscuring');
		case HistoryActionTypeEnum.OSCURAMENTO_RINNOVATO:
			return translateAndFormatText('obscuringRenewed');
		case HistoryActionTypeEnum.OSCURAMENTO_CANCELLATO:
			return translateAndFormatText('obscuringCancelled');
		case HistoryActionTypeEnum.VENDITA:
			return translateAndFormatText('sale');
		default:
			return '';
	}
};

export const translateSfAccountsTypes = (state: string): string => {
    const normalized = state?.trim().toLowerCase() || ""
    switch (normalized) {
        case 'azienda':
        case 'azienda con partita iva':
            return translateAndFormatText("company", false);
        case 'libero professionista':
            return translateAndFormatText("freelancer", false);
        case 'privato':
            return translateAndFormatText("private", false);
        default:
            return state;
    }
}

export const translateSfOpportunityFields = (state: string): string => {
    switch (state) {
        case 'Noleggiatore':
            return translateAndFormatText("rental_company", false);
        case 'Tipologia':
            return translateAndFormatText("typology", false);
        case 'Canale':
            return translateAndFormatText("chanel", false);
				case 'LeadSource':
				case 'Fonte del lead':
						return translateAndFormatText("lead_source", false);
        default:
            return state;
    }
}

export const translateSfTypePickvalues = (state: string): string => {
	switch (state) {
		case 'Noleggio':
			return translateAndFormatText('rent', false);
		case 'Vendita':
			return translateAndFormatText('sale', false);
		default:
			return state;
	}
};

export const translateSfLeadSourcePickvalues = (state: string): string => {
	switch (state?.toLowerCase()) {
		case 'sito web':
			return translateAndFormatText('sito_web', false);
		case 'form contatti sito web':
			return translateAndFormatText('form_contatti_sito_web', false);
		case 'store':
			return translateAndFormatText('store', false);
		case 'dialogo':
			return translateAndFormatText('dialogo', false);
		case 'contatto personale':
			return translateAndFormatText('contatto_personale', false);
		case 'database dealer':
			return translateAndFormatText('database_dealer', false);
		default:
			return state;
	}
};

export const translateOpportunityState = (state: string): string => {
	if (Object.keys(OpportunityStageEnum).includes(state)) {
		return translateAndFormatText(state, false);
	}
	return state;
};
export const translateLeadMotivation = (motivation: string): string => {
	for (const [key, value] of Object.entries(LeadMotivationEnum)) {
		if (value.toLowerCase().trim() === motivation.toLowerCase().trim()) {
			return translateAndFormatText(key, false);
		}
	}
	return motivation;
};

export const translateLeadLogsOutcome = (status: string) => {
	for (const [key, value] of Object.entries(LeadCallResponseEnum)) {
		if (value === status) {
			return translateAndFormatText(key, false);
		}
	}
};

export enum OpportunityCreditStatusEnum {
	credit_approved = 'Pratica approvata',
	credit_rejected = 'Pratica respinta',
	credit_suspended = 'Pratica sospesa',
	credit_awaiting_docs = 'Attesa documenti',
	// credit_unclassified = 'Pratica non classsificata',
	credit_sent = 'Al credito',
	closed_won = 'Chiusa vinta',
	credit_approved_conditionally = 'Pratica approvata condizionata'
}

export const translateOpportunityCreditStatus = (state: string): string => {
	if (Object.keys(OpportunityCreditStatusEnum).includes(state)) {
		return translateAndFormatText(state, false);
	}
	return state;
};
